export default "__VITE_ASSET__Cdl4vIs___"